module.exports = __webpack_public_path__ + "img/exercise-passed-1.333b97e8.png";